import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ChangeAdmin from './ChangeAdmin';
import messages from '../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.changeAdminEmail);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <ChangeAdmin title={title} />
      </AdminLayout>
    ),
  };
}

export default action;
